export enum ActivityConfigItemType {
  /**
   * çº¿ä¸è¯¾ç¨
   */
  ONLINE_COURSE = <any>'ONLINE_COURSE',
  /**
   * ç°åºå¹è®­
   */
  OFFLINE_TRAIN = <any>'OFFLINE_TRAIN',
  /**
   * ç½ç»èè¯
   */
  ONLINE_EXAM = <any>'ONLINE_EXAM',
  /**
   * ç°åºæä½èè¯
   */
  OFFLINE_EXAM = <any>'OFFLINE_EXAM'
}
